import * as zod from "zod";

export const deleteCampaign = {
  name: "deleteCampaign" as const,
  input: zod.object({ campaignId: zod.string() }),
  output: zod.object({ success: zod.boolean() }),
};
